import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppFirstDetails from 'src/components/details/customer-details/AppFirstDetails'
import AppSecondDetails from 'src/components/details/customer-details/AppSecondDetails'

// helpers
import Axios from 'src/helpers/axios'

const CustomerDetails = () => {
  const params = useParams()
  const { id } = params

  const [customerDetails, setCustomerDetails] = useState('')
  const [customerBookingHistory, setCustomerBookingHistory] = useState([])

  useEffect(() => {
    fetchCustomerDetails(id)
  }, [id]);

  useEffect(() => {
    if (customerDetails && customerDetails?.profile && customerDetails?.profile?.id) {
      fetchCustomerBookingHistory(customerDetails?.profile?.id)
    }
  }, [customerDetails]);

  const fetchCustomerDetails = (id) => {
    Axios({
      method: "get",
      url: `/api/sso/v1/users/id/${id}`,
    })
      .then(({ data }) => {
        setCustomerDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchCustomerBookingHistory = (profileId) => {
    Axios({
      method: "get",
      url: `/api/booking/v1/bookings/guest/id/${profileId}`,
    })
      .then(({ data }) => {
        setCustomerBookingHistory(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <AppCard
      className='mb-4'
      headerTitle={
        <AppCardHeader
          headerTitle={<h4>Customer Details</h4>}
        />
      }
      bodyContent={
        <AppFirstDetails
          customerDetails={customerDetails}
          customerBookingHistory={customerBookingHistory}
        />
      }
      lowerBodyContent={
        <AppSecondDetails
          customerDetails={customerDetails}
          customerBookingHistory={customerBookingHistory}
        />
      }
    />
  )
}

export default CustomerDetails
